import { render, staticRenderFns } from "./Matching.vue?vue&type=template&id=16b4581d&scoped=true&"
import script from "./Matching.vue?vue&type=script&setup=true&lang=js&"
export * from "./Matching.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b4581d",
  null
  
)

export default component.exports